import DateFilter from '@/components/date-filter';
import Prestation from "@/components/comptable/prestations-exploitations/prestation"
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import store_operation from "@/store/mods/caisse/operations"
import $ from 'jquery'

export default {
    name: 'charges',
    components: {
        DateFilter, Prestation, EnteteBonEtFacture
    },
    props: [],
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            liste_charges_exploitation: [],

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_loading: true,
            is_empty: false,

            montant_total: 0,
            load_error: false,
            is_printing: false,
            filename: '',
            can_print: false,
            is_month: false,
            personnel_id: "",
            personnel: '',
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                user_id: this.personnel_id
            }
            this.current_date_filter = data

            this.is_month = true
            this.getChargesExploitation(data)
        },

        personnel() {
            this.personnel_id = this.personnel.id

            this.current_date_filter.user_id = this.personnel_id
            this.getChargesExploitation(this.current_date_filter)
        },

    },

    computed: {
        liste_personnel_roles() {
            return this.$store.getters["liste_personnel_roles"];
        },
    },

    mounted() {
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            user_id: this.personnel_id
        }
        this.current_date_filter = data
        this.getChargesExploitation(data)

        const tmpstamp = this.current_date.getHours()+''+this.current_date.getMinutes()+''+this.current_date.getFullYear()
        this.filename = 'Charges d\'exploitation_'+tmpstamp

        this.$store.dispatch("getRolePersonnels").then(() => {
            const all_user = {
				id: "",
				nom: 'Tous(tes) les caissiers(es)',
                titre: "",
                roles: [],
                email: ""
			}
			this.liste_personnel_roles.unshift(all_user)
        })
    },

    methods: {
        getChargesExploitation(data) {
            this.montant_total = 0
            this.is_loading = true
            this.load_error = false

            store_operation.getListeChargesExploitation(data).then((charges) => {
                this.liste_charges_exploitation = charges
                if (this.liste_charges_exploitation.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                    
                    this.liste_charges_exploitation.forEach(charge => {
                        this.montant_total += charge.total_montant
                    });
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.load_error = true
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                user_id: this.personnel_id
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getChargesExploitation(data)
        },

        printChargeExploitation() {
            this.can_print = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
            }, 500);
        },
    }
}